import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import useLegacyProps from '../../hooks/useLegacyProps.js';

var _excluded = ["children", "theme", "columnBanding", "rowBanding"];
var _templateObject;
var StyledTable = styled('table')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-collapse: collapse;\n  border-spacing: 0;\n  margin-bottom: 1rem;\n  max-width: 100%;\n  width: 100%;\n  ", ";\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette[theme.table.backgroundColor];
}, function (_ref2) {
  var theme = _ref2.theme,
    columnBanding = _ref2.columnBanding;
  return columnBanding ? "\n    td:nth-child(odd) {\n      background-color: ".concat(theme.palette[theme.table.rowBandingColor], ";\n    }") : '';
}, function (_ref3) {
  var theme = _ref3.theme,
    rowBanding = _ref3.rowBanding;
  return rowBanding ? "\n    tr:nth-child(even) {\n      background-color: ".concat(theme.palette[theme.table.rowBandingColor], ";\n    }") : '';
});
var Table = function Table(_ref4) {
  var children = _ref4.children,
    _ref4$theme = _ref4.theme,
    theme = _ref4$theme === void 0 ? themes["default"] : _ref4$theme,
    _ref4$columnBanding = _ref4.columnBanding,
    columnBanding = _ref4$columnBanding === void 0 ? false : _ref4$columnBanding,
    _ref4$rowBanding = _ref4.rowBanding,
    rowBanding = _ref4$rowBanding === void 0 ? false : _ref4$rowBanding,
    rest = _objectWithoutProperties(_ref4, _excluded);
  var _useLegacyProps = useLegacyProps(rest),
    className = _useLegacyProps.className,
    style = _useLegacyProps.style;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      overflowX: 'auto'
    }
  }, /*#__PURE__*/React.createElement(StyledTable, _extends({
    theme: theme
  }, rest, {
    columnBanding: columnBanding,
    rowBanding: rowBanding,
    className: className,
    style: style
  }), children));
};
var _Table = withDefaultTheme(/*#__PURE__*/memo(Table));

export default _Table;
